import { CloseButton, SettingsButton, SaveButton } from '@ui/shared/Button';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import {
  closePopup,
  openPopup,
} from '../../../../data/providers/popupsProvider';
import {
  eurReportSettingsProvider,
  IEurReportSettings,
} from '../../../../data/providers/settings/reports/eurReportSettingsProvider';
import { updateEurSettings } from '../../../../data/writers/settings/reports/eurReportSettings';
import { Column } from '../../../layout/Column';
import { CardBody } from '../../../shared/card/CardBody';
import {
  CardFooter,
  CardFooterLeft,
  CardFooterRight,
} from '../../../shared/card/CardFooter';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../../shared/card/CardHeader';
import { LinearLoading } from '../../../shared/loading/LinearLoading';
import { PopupCard, PopupCardContent } from '../../../shared/popups/PopupCard';
import { EurForm } from './Form';

interface IPopupProps {
  onClose: () => void;
  onSave: () => void;
}

export const Popup = (props: IPopupProps): React.ReactElement => {
  const [settings, setSettings] = React.useState<IEurReportSettings>();
  const [loading, setLoading] = React.useState<boolean>(true);

  /**
   * @description subscribe to trend report settings
   */
  React.useEffect((): (() => void) => {
    const subscriber = eurReportSettingsProvider().subscribe(
      (mSettings: IEurReportSettings): void => {
        setSettings(mSettings);
        setLoading(false);
      }
    );

    return (): void => subscriber.unsubscribe();
  }, []);

  /**
   * @description saves the change to database
   */
  const handleSave = async (): Promise<void> => {
    props.onSave();
    setLoading(true);
    await updateEurSettings(settings);
    props.onClose();
  };

  return (
    <PopupCard onClose={props.onClose} size='medium' noClickOutside>
      <PopupCardContent>
        <CardHeader surface={8}>
          <CardHeaderLeft>
            <h6>EUR Report Settings</h6>
          </CardHeaderLeft>
          <CardHeaderRight>
            <CloseButton onClick={props.onClose} />
          </CardHeaderRight>
        </CardHeader>
        <CardBody>
          {loading && <LinearLoading />}
          <Column>
            <EurForm settings={settings} onSettingsChange={setSettings} />
          </Column>
        </CardBody>
        <CardFooter surface={8}>
          <CardFooterLeft />
          <CardFooterRight>
            <SaveButton onClick={handleSave} disabled={loading} />
          </CardFooterRight>
        </CardFooter>
      </PopupCardContent>
    </PopupCard>
  );
};

interface IProps extends RouteComponentProps {
  style?: React.CSSProperties;
  onSave: () => void;
}
export const EurSettings = withRouter((props: IProps): React.ReactElement => {
  const open = (): void =>
    openPopup(
      <Popup onClose={closePopup(props.history)} onSave={props.onSave} />,
      props.history,
      'eur-report-settings'
    );

  return <SettingsButton onClick={open} />;
});
